// extracted by mini-css-extract-plugin
export default {"container":"profile-page_container__Jn9xy"};